import React from 'react'
import classes from './carddetails.module.css'
import { convertToFormatted } from '../../../../util/functions'
import classNames from 'classnames'

const CardDetails = ({
    price,
    attendees,
    showStudentCount = true,
    className = '',
}) => {
    return (
        <div className={classNames(classes.cardDetails, className)}>
            <span className={classes.cardDetailPrice}>
                {convertToFormatted(price, true)}
            </span>
            {showStudentCount && (
                <span className={classes.cardDetailAttendees}>
                    {attendees} attendees
                </span>
            )}
        </div>
    )
}

export default CardDetails
